/* Connect the homepage quick-create and full builder to the Shopify app proxy. */
(() => {
  const endpoint = '/apps/lbox-loadout';
  const guestUseKey = 'lbox-loadout-guest-render-used-v1';
  const guestIdKey = 'lbox-loadout-guest-id-v1';
  const guestAlreadyUsed = () => { try { return localStorage.getItem(guestUseKey) === '1'; } catch { return false; } };
  let transientGuestId = '';
  const guestIdentity = () => {
    const valid = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    try {
      let id = localStorage.getItem(guestIdKey);
      if (valid.test(id || '')) return id;
      id = crypto.randomUUID();
      localStorage.setItem(guestIdKey, id);
      return id;
    } catch {
      try {
        let id = sessionStorage.getItem(guestIdKey);
        if (valid.test(id || '')) return id;
        id = crypto.randomUUID();
        sessionStorage.setItem(guestIdKey, id);
        return id;
      } catch {
        return transientGuestId || (transientGuestId = crypto.randomUUID());
      }
    }
  };

  fetch(`${endpoint}/health`, {headers:{accept:'application/json'}})
    .then(response => response.ok ? response.json() : null)
    .then(health => {
      if (!health?.generation) return;
      window.LBoxLoadoutServices = {
        async generate({file,equipment,poseDirection,signal,onProgress}) {
          const arena = document.querySelector('lbox-loadout');
          if (!arena?.data?.products) throw Error('Loadout catalogue is not ready.');

          let guestId = null;
          const usageResponse = await fetch(`${endpoint}/generation-usage`, {headers:{accept:'application/json'},cache:'no-store'});
          if (usageResponse.status === 401) {
            guestId = guestIdentity();
            const guestUsageUrl = new URL(`${endpoint}/guest-generation-usage`, location.origin);
            guestUsageUrl.searchParams.set('guest_id', guestId);
            const guestUsageResponse = await fetch(guestUsageUrl, {headers:{accept:'application/json'},cache:'no-store'});
            const usage = await guestUsageResponse.json();
            if (!guestUsageResponse.ok && guestUsageResponse.status !== 404) throw Error(usage.error || 'Could not check your guest fighter allowance.');
            if (usage.remaining < 1 || guestAlreadyUsed()) {
              throw Error('Your free guest fighter is used. Sign in or create an account in the full Loadout Lab before generating another.');
            }
          } else if (usageResponse.ok) {
            const usage = await usageResponse.json();
            if (usage.remaining < 1) throw Error(`You have reached your limit of ${usage.limit} fighters for this account.`);
          } else {
            throw Error('Could not check your fighter allowance. Please try again.');
          }

          const photo = await new Promise((resolve,reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(Error('The photo could not be read.'));
            reader.readAsDataURL(file);
          });
          const kit = {};
          for (const [slot,pick] of Object.entries(equipment)) {
            const product = arena.data.products.find(item => item.id === pick.product);
            if (!product?.shopifyId) throw Error(`The ${slot} product needs a live Shopify listing.`);
            kit[slot] = {productId:product.shopifyId,variantId:pick.variant};
          }
          onProgress?.('Creating your fighter with the selected kit…');
          const response = await fetch(`${endpoint}/generate`, {
            method:'POST',headers:{'content-type':'application/json',accept:'application/json'},signal,
            body:JSON.stringify({photo,kit,poseDirection,...(guestId?{guestId}:{})})
          });
          const result = await response.json();
          if (!response.ok) throw Error(result.error || 'Fighter generation failed.');
          if (!result.image) throw Error('The service returned no illustration.');

          const imageResponse = result.image.startsWith('data:image/')
            ? await fetch(result.image)
            : await fetch(new URL(result.image,location.origin),{cache:'no-store'});
          if (!imageResponse.ok) throw Error('The generated fighter could not be loaded.');
          const blob = await imageResponse.blob();
          const imageUrl = URL.createObjectURL(blob);
          if (result.image.startsWith('data:image/')) { try { localStorage.setItem(guestUseKey,'1'); } catch {} }
          const mappedKit = Object.fromEntries((result.kit || []).map(item => [item.slot,{productId:item.productId,variantId:item.variantId}]));
          return {imageUrl,image:result.image,preview:blob,kit:mappedKit,usage:result.usage,loadoutId:result.responseId || result.id || null};
        }
      };
    }).catch(() => {});
})();
